module.exports = __webpack_public_path__ + "img/ico-signarure.35613665.svg";